module.exports = __webpack_public_path__ + "static/icon0030bbc94eb16169b2d359c507850f800da5.png";